import React from "react";
import { MdDelete } from "react-icons/md";
import { MdCloudDownload } from "react-icons/md";
import { FaEdit } from "react-icons/fa";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setCurrentStudentData } from "../features/studentSlice";

const Students = ({setSelectedDeleteID}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const students = useSelector((state) => state.student.students_list);
  const currentStudentData = useSelector(
    (state) => state.student.current_student_data
  );

  const studentList = students.map((el) => {
    return (
      <div
        key={el._id}
        className="flex justify-between items-center p-3 bg-white rounded-xl shadow"
      >
        <div className="flex justify-start gap-4">
          <div className="text-sm font-semibold">
            Scholar's Name:{" "}
            <p className="text-gray-700 text-base">{el.scholar_name}</p>
          </div>
          <div className="text-sm font-semibold">
            Father's Name:{" "}
            <p className="text-gray-700 text-base">{el.father_name}</p>
          </div>
        </div>

        <div className="flex justify-center items-center gap-4 flex-row">
          <MdCloudDownload
            onClick={() => {
              navigate(`/report?id=${el._id}`);
            }}
            className="text-3xl text-gray-600 hover:text-blue-500 cursor-pointer"
          />
          <FaEdit
            onClick={() => {
              navigate(`/studentform?id=${el._id}`);
            }}
            className="text-2xl text-gray-600 hover:text-blue-500 cursor-pointer"
          />
          <MdDelete
            onClick={() => setSelectedDeleteID(el._id)}
            className="text-3xl text-gray-600 hover:text-blue-500 cursor-pointer"
          />
        </div>
      </div>
    );
  });

  return (
    <div className="max-w-6xl my-10  mx-auto bg-gray-50 rounded-xl py-4">
      <div className="flex justify-between px-8 pt-4">
        <div className="flex justify-between items-center w-full">
        <h1 className="text-3xl font-bold text-gray-800">Students List</h1>
        <button
          onClick={() => {
          navigate("/studentform")
          setCurrentStudentData(null)
        }}
          className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded"
        >
          Add Students
        </button>
        </div>

      
      </div>
      <div className="flex flex-col gap-3 mx-8 my-4">{studentList}</div>
    </div>
  );
};

export default Students;
